import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getActivitiesInput,
  getActivityInput,
  ActivityLiteModel,
  ActivityModel,
} from './model';

export function useGetActivities(
  input?: getActivitiesInput,
  options?: UseQueryOptions<ExtendedApiResult<ActivityLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<ActivityLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getActivities', input?.params],
      () =>
        QueryFetchFunction({
          url: 'activities',
          params: input?.params,
        }),
      options,
    ),
    ActivityLiteModel,
  );
}

export function useGetActivity(
  input?: getActivityInput,
  options?: UseQueryOptions<ApiResult<ActivityModel>, ApiError>,
): UseQueryResult<ApiResult<ActivityModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getActivity', input?.id],
      () => QueryFetchFunction({ url: `activities/${input?.id}` }),
      options,
    ),
    ActivityModel,
  );
}

export function getActivitiesKey(input?: getActivitiesInput) {
  return ['getActivities', input?.params];
}

export function getActivityKey(input?: getActivityInput) {
  return ['getActivity', input?.id];
}
